import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      href='#top'
      className='link footer__link'
    >
      Made by Yash
    </a>
  </footer>
)

export default Footer
